import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query ChatProTemplates($integrationId: Int!) {
    chat_pro_templates(integration_id: $integrationId) {
      name
      language
      components {
        body {
          text
        }
      }
      variables
    }
  }
`

export const useTemplateSelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'chat_pro_templates']))
      .then(data => {
        return data.map((item, index) => {
          return {
            id: index,
            name: item.name,
            language: item.language,
            bodyText: pathOr('', ['components', 'body', 'text'], item),
            labels: item.variables || {}
          }
        })
      })
  }
}

const TemplateSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useTemplateSelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} disablePagination={true} {...props} />
}

export default TemplateSelect
